<template>
  <div>
    <vx-card v-if="showMatches" class="mb-10">
      <div class="relative">
        <div>
          <vs-button @click="goBack" color="primary" type="filled"
            >Back</vs-button
          >
          <input
            type="checkbox"
            v-model="allSelected"
            style="float:right;"
            @click="selectAll"
          />
          <template>
            <vs-button
              :color="acceptButtonColor"
              :disabled="selected.length ? false : true"
              type="filled"
              style="float:right;margin-right: 40px;"
              @click="acceptSelected"
              >{{ accept_text }}</vs-button
            >
          </template>

          <vs-button
            color="primary"
            type="filled"
            style="float:right;margin-right: 20px;"
            @click="finishedSelected"
            >Finished</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card v-if="showMatches">
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
      <template v-for="(matched_account, key) in match_accounts">
        <vs-table stripe :key="key" :data="matched_account" class="mb-20">
          <template slot="header">
            <h3 class="pb-5">Match {{ key + paginate.offset + 1}}</h3>
            <h3 class="pb-5">
              Confidence

              {{ parseFloat(matched_account.slave.score).toFixed(2) }} {{ "%" }}
            </h3>
            <input
              type="checkbox"
              v-model="selected"
              @click="select"
              :value="{
                uuid: matched_account.id,
                slave_id: matched_account.slave.ml_id
              }"
            />
            <!-- <vs-checkbox
              v-model="selected"
              :vs-value="{'uuid':matched_account.id,'slave_id':matched_account.slave.ml_id}"
            ></vs-checkbox> -->
          </template>

          <template slot="thead">
            <vs-th v-if="matched_account.slave.ml_company">Company</vs-th>
            <vs-th v-if="matched_account.slave.ml_actual_account_name"
              >Actual Company Name</vs-th
            >
            <vs-th v-if="matched_account.slave.ml_switchboard"
              >Switchboard</vs-th
            >
            <vs-th v-if="matched_account.slave.ml_site_switchboard"
              >Site Switchboard</vs-th
            >

            <vs-th v-if="matched_account.slave.ml_phone">Phone</vs-th>
            <vs-th v-if="matched_account.slave.ml_web">Web</vs-th>
            <vs-th v-if="matched_account.slave.ml_linkedin">Social Media</vs-th>
            <vs-th v-if="matched_account.slave.ml_addresses">Address</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td v-if="matched_account.slave.ml_company">
                {{ matched_account.company_name }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_actual_account_name">
                {{ matched_account.actual_account_name }}
              </vs-td>
              <vs-td v-if="matched_account.slave.switchboard">
                <template v-for="(ph, index) in matched_account.phone">
                  <div :key="index">
                    <template v-for="(ph_type, index2) in ph.phone_type">
                      <div
                        :key="index2"
                        v-if="
                          ph_type.type ==
                            'head_office_switchboard' &&
                            ph_type.phone_id == ph.id
                        "
                      >
                      {{ ph.phone_code }}{{ ph.phone_no }}
                      </div>
                    </template>
                  </div>
                </template>
              </vs-td>
              <vs-td v-if="matched_account.slave.site_switchboard">
                <template v-for="(ph, index) in matched_account.phone">
                  <div :key="index">
                    <template v-for="(ph_type, index2) in ph.phone_type">
                      <div
                        :key="index2"
                        v-if="
                          ph_type.type ==
                            'site_switchboard' &&
                            ph_type.phone_id == ph.id
                        "
                      >
                      {{ ph.phone_code }}{{ ph.phone_no }}
                      </div>
                    </template>
                  </div>
                </template>
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_phone">
                <template v-for="satellite in matched_account.satellite_office">
                  <template v-for="phone in satellite.phone">
                    <div v-if="phone.satellite_office_id == satellite.id">
                      {{ phone.phone_no }}
                    </div>
                  </template>
                </template>
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_web">
                <template v-for="(web, index) in matched_account.web">
                  <div :key="index">
                    {{ web.url }}
                  </div>
                </template>
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_linkedin">
                <template v-for="(linkedin, index) in matched_account.linkedin">
                  <div :key="index">
                    {{ linkedin.url }}
                  </div>
                </template>
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_addresses">
                {{ matched_account.head_office_address_1 }}
                {{ matched_account.head_office_address_2 }}
                {{ matched_account.head_office_address_3 }}
                {{ matched_account.head_office_city }}
                {{ matched_account.head_office_postcode }}
                {{ matched_account.head_office_county }}
                {{ matched_account.head_office_country }}
                {{ matched_account.registered_office_address_1 }}
                {{ matched_account.registered_office_address_2 }}
                {{ matched_account.registered_office_address_3 }}
                {{ matched_account.registered_office_city }}
                {{ matched_account.registered_office_postcode }}
                {{ matched_account.registered_office_county }}
                {{ matched_account.registered_office_country }}
                <template
                  v-for="(satellite, index) in matched_account.satellite_office"
                >
                  <vs-list-item :key="index">
                    {{ satellite.address_1 }}
                    {{ satellite.address_2 }}
                    {{ satellite.address_3 }}
                    {{ satellite.town }}
                    {{ satellite.county }}
                    {{ satellite.postcode }}
                  </vs-list-item>
                </template>
              </vs-td>
            </vs-tr>
            <vs-tr>
              <vs-th v-if="matched_account.slave.ml_company">Company</vs-th>
              <vs-th v-if="matched_account.slave.ml_actual_account_name"
                >Actual Company Name</vs-th
              >
              <vs-th v-if="matched_account.slave.ml_switchboard"
                >Switchboard</vs-th
              >
              <vs-th v-if="matched_account.slave.ml_site_switchboard"
                >Site Switchboard</vs-th
              >
              <vs-th v-if="matched_account.slave.ml_phone">Phone</vs-th>
              <vs-th v-if="matched_account.slave.ml_web">Web</vs-th>
              <vs-th v-if="matched_account.slave.ml_linkedin"
                >Social Media</vs-th
              >
              <vs-th colspan="3" v-if="matched_account.slave.ml_addresses"
                >Address</vs-th
              >
            </vs-tr>
            <vs-tr>
              <vs-td v-if="matched_account.slave.ml_company">
                {{ matched_account.slave.ml_company }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_actual_account_name">
                {{ matched_account.slave.ml_actual_account_name }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_switchboard">
                {{ matched_account.slave.ml_switchboard }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_site_switchboard">
                {{ matched_account.slave.ml_site_switchboard }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_phone">
                {{ matched_account.slave.ml_phone }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_web">
                {{ matched_account.slave.ml_web }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_linkedin">
                {{ matched_account.slave.ml_linkedin }}
              </vs-td>
              <vs-td v-if="matched_account.slave.ml_addresses" rowspan="3">
                {{ matched_account.slave.ml_addresses }}
              </vs-td>
              <vs-td> </vs-td>
              <vs-td> </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
    </vx-card>
    <vx-card v-if="showMachineLearning"
      title="Now You Need To Match Fields For Machine Learning"
      class="mt-5"
    >
      <p>
        On the left are the fields from our database. On the right are the
        fields from the file you have uploaded. Please choose at least two
        columns to get the perfect result.
      </p>

      <!-- <vs-progress  color="primary"></vs-progress>
      <p class="text-center mt-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
      <div class="vx-row p-10">
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header
              title="Database Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <v-select
                    @input="setSelected"
                    class="pb-10 pt-10"
                    :options="list1"
                    v-model="slot.dbfield"
                  />
                </div>
                <div class="vx-col w-full md:w-1/5">
                  <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon>
                </div>
              </div>
            </template>
             <p class="mb-3">
              <span class="text-danger text-sm mt-2 ml-16">{{ validation_message }}</span>
            </p>
          </vs-list>
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            @click="addAnother"
            >Add another column</vs-button
          >
        </div>
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header
              title="Uploaded Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <!-- <v-select
                v-if="slot.dbfield != 'address'"
                class="pb-10 pt-10"
                label="Company"
                :options="csv_table_fields"
                :key="index"
                v-model="slot.uploadfield"
              /> -->
              <v-select
                multiple
                :closeOnSelect="false"
                class="pb-10 pt-10"
                :options="csv_table_fields"
                :key="index"
                v-model="slot.uploadfield"
              />
            </template>
          </vs-list>
        </div>
        <div class="vx-col w-full md:w-1/3">
          <div class="p-10">
            <p>
              * Combine address field for all address fields
              e.g.address,city,country
            </p>
            <p>
              if you're finished then click on proceed button to get the match
              results.It may take some time.
            </p>
            <!-- <vs-progress  color="primary"></vs-progress> -->
            <!-- <p class="text-center m-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
            <vs-button
              @click="matchField(paginate)"
              color="primary"
              type="filled"
              style="float:right;"
              >Match Field</vs-button
            >
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import ImportExcel from "@/components/excel/ImportExcel.vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    draggable,
    Prism,
    vSelect
  },
  data() {
    return {
      showMachineLearning:true,
                              abilities : null,

      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      match_ten_context: [],
      validation_message: "",
      total_pages: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      showMatches: false,
      match_accounts: [],
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      csv_table_fields: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      list1: [
        {
          id: 1,
          name: "company_name",
          value: "company_name",
          label: "Company Name",
          selection: true
        },
        {
          id: 2,
          name: "actual_account_name",
          value: "actual_account_name",
          label: "Actual Account Name",
          selection: true
        },
        {
          id: 3,
          name: "switchboard",
          value: "switchboard",
          selection: true,
          label: "Switchboard"
        },
        {
          id: 4,
          name: "site_switchboard",
          value: "site_switchboard",
          selection: true,
          label: "Site Switchboard"
        },
        {
          id: 5,
          name: "address",
          value: "address",
          selection: true,
          label: "Address"
        },
        {
          id: 6,
          name: "website",
          value: "website",
          selection: true,
          label: "Website"
        },
        {
          id: 7,
          name: "linkedin",
          value: "linkedin",
          selection: true,
          label: "Social Media"
        },
        {
          id: 8,
          name: "phone",
          value: "phone",
          selection: true,
          label: "Phone"
        }
      ]
    };
  },
  mounted() {


    
    this.getColumnsFromCSVTable()
  },
  watch: {
    currentx: function(val) {
      this.paginate = { limit: this.limit, offset: (val - 1) * this.limit + 1 };
      this.paginateState();
      this.allSelected = true;
      this.match_ten_context.forEach(
        function(ele) {
          if (ele.page == val && !ele.ten_selected) {
            this.allSelected = false;
          }
        }.bind(this)
      );
    }
  },
  methods: {
    acceptSelected() {
      let selected_data = {};
      selected_data.selected = this.selected;
      selected_data.table_name = this.table_name;


      //  console.log(this.selected)
      //  return false


      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/save_matched_account",
          selected_data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.accept_text = "Accepted";
            this.acceptButtonColor = "success";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getColumnsFromCSVTable(){
      let self = this
      let data = {};
      data.table_name = this.table_name
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/get_ml_account_columns_from_table",
          data
        )
        .then(response => {
            let result = response.data

            let columns = JSON.parse(result.selected_fields)

            columns.forEach(function(ele,index){

              let label =  null
              let prefix = "enh_";

              if (ele.startsWith(prefix)) {
                  label = ele.slice(prefix.length);
                }

            self.csv_table_fields.push({
                label :  label,
                name: ele,
            })
          
        })
        }).catch(error => {
            console.log(error);
          });
    },
    validatetUserUploaded() {
      let data = {};
      data.table_name = 'temp_' + this.selected_campaign["id"].replaceAll("-", "_") + '_accounts';
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/get_user_uploaded_table_name",
          data
        )
        .then(response => {
          if (response.data === undefined || response.data.length == 0) {
            this.table_name_exists = null;
            if (this.upload_validation == true) {
              this.upload_validation_message = null;
              this.showImportWidget = false;
              this.$vs.loading.close();
            } else {
              this.upload_validation_message = "Please upload a file";
            }
          } else {
            this.table_name_exists =
              "File name already exists. Please try another";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    finishedSelected() {


      this.$router.push({
  name: "enhanceaccountmachinelearningRemainder",
  params: { table: this.$route.params.table , selected_fields: this.$route.params.selected_fields }
});




      // this.$router.push({
      //   name: "enhanceaccountmachinelearningRemainder",
      //   params: { tableId: this.table_name }
      // });
    },
    setSelected(field) {
      // this.list1 = this.list1.filter(function(el) {
      //   return el.name != field.name;
      // });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      s = s.replace("_", " ");
      s = s.replace("_", " ");
      s = s.replace("slave", " ");
      s = s.replace("master", " ");
      s = s.replace("_", " ");
      s = s.replace("ml", " ");
      s = s.replace("_", " ");
      return this.ucFirstAllWords(s);
    },
    goBack: function() {
      this.showMatches = false;
            this.showMachineLearning = false;

      
    },
    addAnother: function() {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: [],
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function(ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validatetUserUploaded();
        }
      });
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {
      let matches = this.match_accounts;
      if (this.allSelected) {
        matches.forEach(match => {
          this.selected.pop({ uuid: match.id, slave_id: match.slave.ml_id });
        });
      } else {
        matches.forEach(match => {
          this.selected.push({ uuid: match.id, slave_id: match.slave.ml_id });
        });
        this.match_ten_context.map(
          function(ele) {
            if (ele.page == this.currentx) {
              return (ele.ten_selected = true);
            }
          }.bind(this)
        );
      }
    },
    select() {
      this.allSelected = false;
      this.match_ten_context.map(
        function(ele) {
          if (ele.page == this.currentx) {
            return (ele.ten_selected = false);
          }
        }.bind(this)
      );
    },
    getCsvFileName(value) {
      this.csv_filename = value;
      // this.table_name = this.csv_filename.replace(/\.[^.$]+$/, '');
    },
    matchField(paginate) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.fieldgroups[0].paginate = this.paginate;
      this.fieldgroups[0].csv_filename = this.csv_filename;
      this.fieldgroups[0].table_name = this.table_name;
      this.fieldgroups[0].user_info = userInfo;
      this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/match_ml_accounts",
          this.fieldgroups
        )
        .then(response => {
          let self = this
          if (response.data.status == "fail") {
            this.validation_message = response.data.message;
          } else {
            if (response.data === undefined || response.data.length == 0) {
              // this.finishedEnhanced();
              this.$vs.notify({
                color: "danger",
                title: "Import Account",
                text:
                  "No record matches has been found. Please upload other files that contains matched accounts."
              });
              self.$router.push("/resume_enhance_account_machine_learning");

              // self.$router.replace("/accounts/unmatched/" + this.$route.params.table);
              // this.showMatches = false;
              // this.showImportWidget = true;
            } else {
              this.match_accounts = response.data;
              this.total_pages = Math.ceil(
                this.match_accounts[0].total_pages / this.limit
              );
              if (this.match_ten_context.length == 0) {
                for (var i = 0; i < this.total_pages; i++) {
                  this.match_ten_context.push({
                    page: i + 1,
                    ten_selected: false
                  });
                }
              }

              this.showMatches = true;
              this.showMachineLearning = false;
              this.showFieldComparision = false;
              this.showImportWidget = false;
              this.selected = this.removeDuplicates(this.selected, "uuid");
            }
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    finishedEnhanced() {
      let tableData = {};
      tableData.table_name = this.table_name;
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/finish_machine_learning_enhance",
          tableData
        )
        .then(response => {
          // console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    paginateState() {
      let data = {};
      data.table_name = this.table_name;
      data.paginate = this.paginate;
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/match_accounts_pagination",
          data
        )
        .then(response => {
          if (response.data.status == "fail") {
            this.validation_message = response.data.message;
          } else {
            this.match_accounts = response.data;
            this.total_pages = Math.ceil(
              this.match_accounts[0].total_pages / this.limit
            );
            if (this.match_ten_context.length == 0) {
              for (var i = 0; i < this.total_pages; i++) {
                this.match_ten_context.push({
                  page: i + 1,
                  ten_selected: false
                });
              }
            }

            this.showMatches = true;
                          this.showMachineLearning = false;

            this.showFieldComparision = false;
            this.selected = this.removeDuplicates(this.selected, "uuid");
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
    created(){
     var self = this
     this.table_name = atob(this.$route.params.table);
     console.log(this.table_name)
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
